
export const TimingTokens = {
  objTransition: '400ms',
  propTransition: '200ms',
  tinySubtle: '50ms',
};
